import axios from "axios";
import { getAuthTokenFromLS, getOrCreateDeviceId, getOrCreateBrowserSessionId, clearAuthStorage } from "./common";
import { BASE_URL } from "./constant";
import { useDispatch } from "react-redux";
import { persistor, store } from "../redux/store";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 100000,
  headers: {
    "Authorization": getAuthTokenFromLS() || sessionStorage.getItem("jwttoken") || "",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {

    config.headers["Authorization"] = getAuthTokenFromLS() || sessionStorage.getItem("jwttoken") || "";
    config.headers["x-device-id"] = getOrCreateDeviceId();
    config.headers["x-session-id"] = getOrCreateBrowserSessionId();

    return config;
  },
  (error) => {

    return Promise.reject(error);
  }
);

const forceLogout = (redirectTo) => {
  store.dispatch({ type: "USER_LOGOUT" });
  persistor.purge();
  clearAuthStorage();
  // Only navigate when we are not already there. Reloading /login from a 401
  // that fired on /login would restart the same request and loop. The redux
  // store and storage have already been purged above, so staying put is clean.
  if (window.location.pathname !== redirectTo) {
    window.location.replace(redirectTo);
  }
};

axiosInstance.interceptors.response.use(
  (config) => {

    // Some auth failures still arrive as HTTP 200 carrying a FAILURE envelope, so
    // detect them from the payload rather than relying on the status code alone.
    if (config?.data?.result?.status === "UNAUTHORIZED") {
      forceLogout("/login");
      return Promise.reject(new Error(config?.data?.message || "Unauthorized"));
    }

    if (config?.data?.message === "Authorization Invalid" || config?.data?.message === "invalid token") {
      forceLogout("/login");
      return Promise.reject(new Error(config?.data?.message));
    }
    return config;
  },
  (error) => {
    // A transport failure is NOT an auth failure. `!error.response` covers
    // timeouts, offline, cancelled requests and CORS errors, so treating it as a
    // logout meant any network blip signed the user out. Let the caller handle it.
    if (error.response && error.response.status === 401) {
      // Clear local storage and redirect to the login page
      forceLogout("/login");
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
export default axiosInstance;